import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {ImageSlideItemObject} from '@PosterWhiteboard/items/slideshow-item/slide-items/image-slide-item.class';

export function useGetKeyFromSelectedImageSlide<T extends keyof ImageSlideItemObject>(key: T): ImageSlideItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem.gitype === ITEM_TYPE.IMAGESLIDE) {
        const imageSlide = slideItem as ImageSlideItemObject;
        return imageSlide[key];
      }
    }

    return undefined;
  });
}
